import {useLocalStorage} from '@vueuse/core';
import {ref} from 'vue';

export const SIDE_MENU_COLLAPSED = 'sideMenuCollapsed';
const isSidebarCollapsed = useLocalStorage(SIDE_MENU_COLLAPSED, false);
const isMobileSidebarVisible = ref(false);

export default function useSidebarToggle() {
  const collapseSidebar = () => {
    isSidebarCollapsed.value = true;
  };

  const expandSidebar = () => {
    isSidebarCollapsed.value = false;
  };

  const openMobileSidebar = () => {
    isMobileSidebarVisible.value = true;
  };

  const closeMobileSidebar = () => {
    isMobileSidebarVisible.value = false;
  };

  return {
    isSidebarCollapsed,
    collapseSidebar,
    expandSidebar,
    isMobileSidebarVisible,
    openMobileSidebar,
    closeMobileSidebar,
  };
}
